import { Button } from '@chakra-ui/react';
const CUIButton = Button;
export default CUIButton;